// MCP Security — Outcome pill.
//
// Lifted from the Events page so Overview, Events, Sessions, Agents
// drawers etc. render decision outcomes with the same colour mapping.
// Also exports `outcomePalette()` for callers that want to pick
// their own box-shape (e.g. the drawer header).

import React from "react";
import { Chip } from "@mui/material";
import tokens from "./tokens";

export const OUTCOME_PALETTE = {
  pass:                     { label: "Pass",              fg: "#1E6B3F", bg: "#E6F4EC", border: "#A5D5B9" },
  suppress:                 { label: "Suppressed",        fg: "#1E6B3F", bg: "#E6F4EC", border: "#A5D5B9" },
  tag:                      { label: "Tagged",            fg: "#1A4FBF", bg: "#E5EEFC", border: "#B9CCF2" },
  rate_limit:               { label: "Rate limited",      fg: "#8A6410", bg: "#FFF4D6", border: "#F3DC9A" },
  session_integrity:        { label: "Session block",     fg: "#5B2D8E", bg: "#F2E6FA", border: "#D7BFEE" },
  session_cap:              { label: "Session cap",       fg: "#8A6410", bg: "#FFF4D6", border: "#F3DC9A" },
  scope_denied:             { label: "Scope denied",      fg: "#5B2D8E", bg: "#F2E6FA", border: "#D7BFEE" },
  prompt_injection_blocked: { label: "Injection block",   fg: "#8E1F1F", bg: "#FBE8E8", border: "#E8B8B8" },
  response_too_large:       { label: "Response cap",      fg: "#8E1F1F", bg: "#FBE8E8", border: "#E8B8B8" },
  credential_leak:          { label: "Credential",        fg: "#8E1F1F", bg: "#FBE8E8", border: "#E8B8B8" },
  drift_block:              { label: "Drift hold",        fg: "#8E1F1F", bg: "#FBE8E8", border: "#E8B8B8" },
  block_new_tool:           { label: "New tool blocked",  fg: "#8E1F1F", bg: "#FBE8E8", border: "#E8B8B8" },
};

export function outcomePalette(outcome) {
  const k = String(outcome || "").toLowerCase();
  return OUTCOME_PALETTE[k] || {
    label: outcome || "—",
    fg: tokens.neutral[800],
    bg: tokens.neutral[100],
    border: tokens.neutral[200],
  };
}

/**
 * Small inline pill. Can render as either an MUI Chip (default) or a
 * raw span for very dense tables / drawer timelines.
 */
export default function OutcomePill({ outcome, variant = "chip", sx }) {
  const p = outcomePalette(outcome);
  if (variant === "span") {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          fontFamily: tokens.fontMono,
          fontSize: 11,
          padding: "2px 8px",
          borderRadius: 999,
          whiteSpace: "nowrap",
          background: p.bg,
          color: p.fg,
          ...sx,
        }}
      >
        {p.label}
      </span>
    );
  }
  return (
    <Chip
      size="small"
      label={p.label}
      sx={{
        backgroundColor: p.bg,
        color: p.fg,
        border: `1px solid ${p.border}`,
        fontSize: 11,
        height: 22,
        fontWeight: 500,
        borderRadius: "11px",
        ...sx,
      }}
    />
  );
}
